// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 10px 0;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.page-item {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px;
  font-weight:lighter;
}

.page-link {
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;

}

.page-link:hover {
  background-color: #e9ecef;
  color: #F37920;
}

.page-item.active  {
  background-color: #F37920 !important;
  color: white;
  border-color: #F37920;
}

.page-item.disabled .page-link {
  color: #6c757d;
  cursor: not-allowed;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/common/PaginationComponent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;;AAEtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".pagination-container {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 10px 0;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.page-item {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 8px;\n  font-weight:lighter;\n}\n\n.page-link {\n  display: block;\n  padding: 8px 12px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s;\n\n}\n\n.page-link:hover {\n  background-color: #e9ecef;\n  color: #F37920;\n}\n\n.page-item.active  {\n  background-color: #F37920 !important;\n  color: white;\n  border-color: #F37920;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  cursor: not-allowed;\n  background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
